// removed by extract-text-webpack-plugin
module.exports = {"copyright":"Copyright__copyright___RQsS8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Copyright.scss
// module id = 5mmF
// module chunks = 0